module.exports = __webpack_public_path__ + "img/craftBannerRollerBlindsMobile.c882571.webp";